"use client";

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  Container,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  styled,
} from "@mui/material";
import ProviderHeader from "./components/ProviderHeader";
import WeeklySchedule from "./components/WeeklySchedule";
import CardManagement from "./components/CardManagement";
import ContentTabs from "./components/content-tabs";
import { mapStateToProps, mapDispachToProps } from "../../../store/MapToProps";
import { getData } from "../../../utils/helpers";
import BranchManagement from "./components/BranchManagement";
import OfferManagement from "./components/OfferManagement";
import SeasonManagement from "./components/SeasonManagement";
import MatchManagement from "./components/MatchManagement";
import TicketManagement from "./components/TicketManagement";
import StoryManagement from "./components/StoryManagement";

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

const SectionCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.1)",
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

const ProviderInfo = (props) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.state?.id) {
      getData(props, location.state.pageTitle, location.state.id);
    }
  }, []);

  const provider = props?.providers?.data;

  const updateProviderInfo = async (data) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (data[key] instanceof File) {
        formData.append(key, data[key]); // Append file directly
      } else if (typeof data[key] === "object" && data[key] !== null) {
        formData.append(key, JSON.stringify(data[key])); // Send objects as JSON string
      } else {
        formData.append(key, data[key]);
      }
    });

    props?.enableLoder();
    await props?.updateProvider(formData, { "Content-Type": "multipart/form-data" });
    setTimeout(() => {
      window?.location?.reload();
    }, 2000);
  };



  if (!provider) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <StyledContainer maxWidth="xl">
      <Grid container spacing={4}>
        {/* Provider Information Section */}
        <Grid item xs={12}>
          <SectionCard>
            <CardContent>
              <ProviderHeader
                provider={provider}
                onUpdate={updateProviderInfo}
              />
            </CardContent>
          </SectionCard>
        </Grid>

        {/* Schedule and Cards Section */}
        <Grid item xs={12} lg={6}>
          <SectionCard>
            <CardContent>
              <SectionTitle variant="h5">Operating Hours</SectionTitle>
              <WeeklySchedule providerId={provider} />
            </CardContent>
          </SectionCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <SectionCard>
            <CardContent>
              <SectionTitle variant="h5">Bonus Cards</SectionTitle>
              <CardManagement provider={provider} />
            </CardContent>
          </SectionCard>
        </Grid>

        {/* Content Management Section */}
        <Grid item xs={12}>
          <SectionCard>
            <CardContent>
              <SectionTitle variant="h5">Content Management</SectionTitle>
              <ContentTabs provider={provider} />
            </CardContent>
          </SectionCard>
        </Grid>
      </Grid>

      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Branches</SectionTitle>
            <BranchManagement provider={provider} token={props.token} />
          </CardContent>
        </SectionCard>
      </Grid>

      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Story</SectionTitle>
            <StoryManagement provider={provider} />
          </CardContent>
        </SectionCard>
      </Grid>
      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Offers</SectionTitle>
            <OfferManagement provider={provider} token={props.token} />
          </CardContent>
        </SectionCard>
      </Grid>

      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Seasons</SectionTitle>
            <SeasonManagement provider={provider} token={props.token} />
          </CardContent>
        </SectionCard>
      </Grid>

      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Matches</SectionTitle>
            <MatchManagement provider={provider} token={props.token} />
          </CardContent>
        </SectionCard>
      </Grid>

      <Grid item xs={12} lg={6}>
        <SectionCard>
          <CardContent>
            <SectionTitle variant="h5">Ticket</SectionTitle>
            <TicketManagement provider={provider} token={props.token} />
          </CardContent>
        </SectionCard>
      </Grid>
    </StyledContainer>
  );
};

export default connect(mapStateToProps, mapDispachToProps)(ProviderInfo);
